module.exports = __webpack_public_path__ + "img/k-3_img.8114e825.png";